import styled from 'styled-components';

export const ChartContainer = styled('section')`
  display: grid;
  place-content: center;
`;
